import { dataManagementService } from '@/api/dataManagementService';
import { lidService } from '@/api/lidService';

export * from '@/api/lidService';
export * from '@/api/dataManagementService';

export const authRequireServices = [lidService, dataManagementService];
